<template>
  <div class="printFaceOrder column-me">
    <div class="row-me width100Per height100Per">
      <div class="left-div column-me">
        <div class="row-me row-center padding-bottom20">
          <div class="font-bold">选择模板：</div>
          <div class="width300">
            <el-select placeholder="请选择" style="width: 100%;" filterable clearable v-model="selectTemplate"
                       @change="templateChange">
              <el-option v-for="item in templateArray" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex1 overflow-auto padding-right10" v-dragscroll.y="true">
          <div class="margin-bottom30" v-for="(item,index) in showOrderArray" :key="index">
            <div class="font-bold" v-if="source==='normal'">处方{{ index + 1 }}&emsp;处方订单号：{{ item.orderNo }}</div>
            <div class="font-bold" v-if="source==='link'">联单{{ index + 1 }}&emsp;联单号：{{ item.jointNo }}</div>
            <div class="row-me row-center margin-top20">
              <div class="left-title">寄件类型：</div>
              <div class="width270 margin-left10">
                <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                           v-model="item.sendType" :disabled="item.faStatus===1||item.faStatus===2">
                  <el-option v-for="item in ['标快','特快']" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="row-me row-center margin-top10">
              <div class="left-title">运费方式：</div>
              <div class="width270 margin-left10">
                <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                           v-model="item.deliveryType" :disabled="item.faStatus===1||item.faStatus===2">
                  <el-option v-for="item in deliveryTypeArray" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="row-me row-center margin-top10">
              <div class="left-title">是否保价：</div>
              <div class="margin-left10">
                <el-radio-group v-model="item.isInsure" :disabled="item.faStatus===1||item.faStatus===2">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="row-me margin-top10">
              <div class="left-title">收件人信息：</div>
              <div class="column-me flex1 margin-left10">
                <div class="row-me row-center">
                  <div class="flex1">
                    <el-input placeholder="请输入收件人姓名" style="width: 100%;" clearable
                              v-model="item.receiveName" :disabled="item.faStatus===1||item.faStatus===2"></el-input>
                  </div>
                  <div class="flex1 margin-left10">
                    <el-input placeholder="请输入收件人电话" style="width: 100%;" clearable
                              @input="item.receiveMobile=this.$method.checkInput(item.receiveMobile,0)"
                              v-model="item.receiveMobile" :disabled="item.faStatus===1||item.faStatus===2"></el-input>
                  </div>
                </div>
                <div class="row-me row-center margin-top10">
                  <div class="flex1">
                    <el-select v-model="item.receiveProvince" placeholder="请选择省" style="width: 100%;" filterable
                               clearable @change="e=>provinceChange(e,item)"
                               :disabled="item.faStatus===1||item.faStatus===2">
                      <el-option v-for="item in provinceArray" :key="item.id" :label="item.n"
                                 :value="item.n">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="flex1 margin-left10">
                    <el-select v-model="item.receiveCity" placeholder="请选择市" style="width: 100%;" filterable
                               clearable @change="e=>cityChange(e,item)"
                               :disabled="item.faStatus===1||item.faStatus===2">
                      <el-option v-for="item in cityArray" :key="item.id" :label="item.n" :value="item.n">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="flex1 margin-left10">
                    <el-select v-model="item.receiveRegion" placeholder="请选择区/县" style="width: 100%;" filterable
                               clearable :disabled="item.faStatus===1||item.faStatus===2">
                      <el-option v-for="item in areaArray" :key="item.id" :label="item.n" :value="item.n">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex1 margin-top10">
                  <el-input placeholder="请输入详细地址" style="width: 100%;" clearable
                            v-model="item.receiveAddress" :disabled="item.faStatus===1||item.faStatus===2"
                            maxlength="50"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row-me flex-end1 margin-top20">
          <div class="btn-blue width120 btn-height40" @click="clickCreateFaceOrder">生成面单</div>
        </div>
      </div>
      <div class="margin-left50 column-me flex1 overflow-auto height100Per">
        <div class="font-bold">面单预览：</div>
        <div class="row-me flex-wrap flex1 margin-top20 overflow-auto">
          <div class="item-face" v-for="(item,index) in faceOrderArray" :key="index">
            <embed :src="item.pdf" type="application/pdf" width="100%" height="100%">
          </div>
        </div>
        <div class="row-me flex-end1 margin-top20">
          <div class="btn-blue width120 btn-height40" @click="clickPrint">打印面单</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cityData from '../../assets/js/citys.js'
import Print from 'print-js'

let interval;//监听面单生成结果
export default {
  components: {},
  props: {
    orderArray: {
      type: Array,
      default: () => [],
    },
    source: {//页面来源，普通订单：normal，联单：link
      type: String,
      default: '',
    }
  },
  data() {
    return {
      selectTemplate: '',
      templateArray: [],
      deliveryTypeArray: [{id: 0, name: '寄付现结'}, {id: 1, name: '到付'}, {id: 2, name: '寄付月结'}],
      showOrderArray: [],
      provinceArray: [],
      cityArray: [],
      areaArray: [],
      faceOrderArray: [],//面单
    }
  },
  // 侦听器
  watch: {
    "selectTemplate"(newVal, oldVal) {
      for (let item of this.showOrderArray) {
        item.modelId = newVal
      }
    },
  },
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.provinceArray = cityData
    this.showOrderArray = []
    console.log(this.source)
    for (let item of this.orderArray) {//筛选出顺丰速运的
      if (item.deliveryCompany.indexOf('顺丰') !== -1) {
        item.sendType = '标快'
        item.sendMethod = '上门取件'
        item.isInsure = false
        item.orderId = item.id
        item.type = this.source === 'link' ? 2 : 1//1其他发货，2联单发货
        this.showOrderArray.push(item)
      }
    }
    this.getTemplateArray()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    templateChange(e) {
      this.faceOrderArray = []
    },
    provinceChange(e, item) {
      item.receiveCity = ''
      item.receiveRegion = ''
      this.cityArray = []
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.provinceArray.length; i++) {
          let item = this.provinceArray[i]
          if (e === item.n) {
            this.cityArray = item.c
          }
        }
      }
    },
    cityChange(e, item) {
      item.receiveRegion = ''
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.cityArray.length; i++) {
          let item = this.cityArray[i]
          if (e === item.n) {
            this.areaArray = item.c
          }
        }
      }
    },
    //生成面单
    clickCreateFaceOrder() {
      if (this.$method.isEmpty(this.selectTemplate)) {
        this.$message.error("请先选择模板")
        return;
      }
      let title = this.source === 'normal' ? '处方' : this.source === 'link' ? '联单' : ''
      for (let i = 0; i < this.showOrderArray.length; i++) {
        let item = this.showOrderArray[i]
        if (this.$method.isEmpty(item.sendType)) {
          this.$message.error(title + (i + 1) + '的寄件类型不能为空')
          return
        }
        if (this.$method.isEmpty(item.deliveryType)) {
          this.$message.error(title + (i + 1) + '的运费方式不能为空')
          return
        }
        if (this.$method.isEmpty(item.receiveName) || this.$method.isEmpty(item.receiveMobile)
            || this.$method.isEmpty(item.receiveProvince) || this.$method.isEmpty(item.receiveCity)
            || this.$method.isEmpty(item.receiveRegion) || this.$method.isEmpty(item.receiveAddress)) {
          this.$message.error(title + (i + 1) + '的收件人信息请填写完整')
          return
        }
      }
      this.$postRequest('/admin/sfExpress/printModel', this.showOrderArray).then((res) => {
        if (res) {
          this.$message.success(res.message)
          setTimeout(() => {
            this.getFaceOrderPdf()
          }, 1000)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //打印面单
    clickPrint() {
      if (this.faceOrderArray.length === 0) {
        this.$confirm("请先点击“生成面单”，耐心等待面单显示后，再打印", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
        return
      }
      this.goPrint(0)
    },
    //循环获取面单pdf
    getFaceOrderPdf() {
      let ids = this.showOrderArray.map(item => {
        return item.id
      })
      interval = setInterval(() => {
        this.$postRequest('/admin/sfExpress/getPDF', {
          ids: ids,
          type: this.source === 'link' ? 2 : 1//type:1普通的，2联单
        }).then((res) => {
          if (res) {
            if (!this.$method.isEmpty(res.data) && res.data.length > 0) {
              if (interval) {
                clearInterval(interval)
              }
              this.faceOrderArray = res.data
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      }, 500)
    },
    goPrint(index) {
      if (index < this.faceOrderArray.length) {
        Print({
          printable: this.faceOrderArray[index].base64,
          type: "pdf",
          showModal: false,
          base64: true,
          frameId: index,
        });
        this.goPrint(++index)
      }
    },
    //获取模板下拉
    getTemplateArray() {
      this.$postRequest('/admin/sfExpress/modelList', {}).then((res) => {
        if (res) {
          this.templateArray = res.data
          if (this.templateArray.length > 0) {
            this.selectTemplate = this.templateArray[0].id
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  unmounted() {
    if (interval) {
      clearInterval(interval)
    }
  },
}
</script>

<style lang="scss" scoped>
.printFaceOrder {
  height: 80vh;

  .left-div {
    width: 600px;
    height: 100%;
    overflow: auto;
  }

  .left-title {
    width: 110px;
    text-align: right;
  }

  .item-face {
    width: 100%;
    height: 100%;
    border: 1px solid #cccccc;
    display: inline-block;
    margin-right: 30px;
  }
}
</style>
